export default "__VITE_ASSET__DIh6WHSz__"